export default __webpack_public_path__ + "static/media/crypto-news-img.0d89dd2a.jpeg";